import { Component, OnDestroy, OnInit } from '@angular/core';
import { reportTitle } from '../../../core/constants/constants';
import { ReportsService } from '../../../core/service/reports.service';
import {
  MXReport,
  RootObject,
  TrackMXSummaryResponse,
  TrackMXVareQResponse,
  TrackMXVareQVarianceResponse,
  TrackMXVarResponse,
  TrackMXVarVarianceResponse,
} from '../../../core/interface/mx-reports';
import { Subscription } from 'rxjs';
import { CommonService } from '../../../core/service/common.service';
import { SessionStorageService } from '../../../core/service/session-storage';
import { DataService } from '../../../core/service/data_service';
import { VarianceReportData } from '../../../core/interface/export-reports';

@Component({
  standalone: false,
  selector: 'app-track-reports',
  templateUrl: './track-reports.component.html',
  styleUrl: './track-reports.component.less',
})
export class TrackReportsComponent implements OnInit, OnDestroy {
  reportTitle = reportTitle;
  trackMXSummaryResponse!: TrackMXSummaryResponse;
  trackMXVareQResponse!: TrackMXVareQResponse[];
  trackMXVarResponse!: TrackMXVarResponse[];
  trackMXVareQVarianceResponse!: TrackMXVareQVarianceResponse[];
  trackMXVarVarianceResponse!: TrackMXVarVarianceResponse[];
  reportData!: VarianceReportData;
  routerData!: VarianceReportData;
  getMXReports!: Subscription;
  facId!: string;
  facilityIdSubscription!: Subscription;

  constructor(
    private readonly reportsService: ReportsService,
    private readonly commonService: CommonService,
    private readonly session: SessionStorageService,
    private readonly dataService: DataService
  ) {}
  ngOnInit(): void {
    this.commonService.setNavigationDisabled(true);

    if (this.session.getItem('userAccess')) {
      this.facId = this.session.getItem('userAccess')['faC_ID'];
    }

    this.facilityIdSubscription = this.dataService.getFacilityId.subscribe({
      next: (fac_id: string) => {
        this.facId = fac_id;
      },
      error: (error) => {
        console.error('Error in fetching facility id :', error);
      },
    });

    this.routerData = history.state.data;
    if (this.routerData) {
      this.reportData = {
        contractor: this.routerData.contractor,
        date: this.formatDate(this.routerData.date),
      };
      this.loadMxReports();
    }
  }

  formatDate(date: string) {
    return date.split(' ')[0];
  }

  loadMxReports() {
    const data: MXReport = {
      date: this.reportData.date,
      vendor: this.reportData.contractor,
      facID: this.facId,
    };
    this.getMXReports = this.reportsService.getMXReports(data).subscribe({
      next: (response: RootObject | null) => {
        if (response != null) {
          this.trackMXSummaryResponse = response.trackMXSummaryResponse;
          this.trackMXVareQResponse = response.trackMXVareQResponse;
          this.trackMXVarResponse = response.trackMXVarResponse;
          this.trackMXVareQVarianceResponse =
            response.trackMXVareQVarianceResponse;
          this.trackMXVarVarianceResponse = response.trackMXVarVarianceResponse;
        }
      },
      error: (error) => {
        console.log('Error occured in loadMxReports method. Error: ', error);
      },
      complete: () => {},
    });
  }

  ngOnDestroy(): void {
    if (this.getMXReports) {
      this.getMXReports.unsubscribe();
    }

    if (this.facilityIdSubscription) {
      this.facilityIdSubscription.unsubscribe();
    }

    this.commonService.setNavigationDisabled(false);
  }
}
